import ListItems from './ListItems';

const debug = false;

export default class BillboardListItems extends ListItems {

  constructor(element) {
    super(element);

    // this.currentEdition = items.length && items[items.length - 1].dataset.edition;
  }

  updateItem = (item, div) => {
    // PITTI20-1309
    // (item.dataset.edition !== this.currentEdition) && div.insertAdjacentHTML('beforeend', `<h2 class="news-edition-title">Ed. ${item.dataset.edition} - ${item.dataset.monthYear}</h2>`);
    // this.currentEdition = item.dataset.edition;
    if (item.classList.contains('news-edition-title') && this.$el.querySelector(`.news-edition-title[data-edition="${item.dataset.edition}"]`)) {
      return;
    }

    // TODO TypeError: _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(...) is undefined
    // super.updateItem(item, div);
    if (this.$options.preventDuplicates && item.dataset.listItemId) {
      const duplicate = this.itemIds.has(item.dataset.listItemId);
      debug && console.log('ListItems updateItem itemId', item.dataset.listItemId, 'duplicate', duplicate);
      if (duplicate) {
        return;
      }
      this.itemIds.add(item.dataset.listItemId);
    }
    this.listing.appendChild(item);
    initVideos(item);

    // PITTI20-1211
    // document.dispatchEvent(new Event('image-changes'));
  }
}
